<template>
  <div class="row jipvio-dashboard">
    <button @click=test()></button>
    <div class="col-12">
      <card class="mt-70" card-body-classes="table-full-width" no-footer-line>
        <h4 class="card-title ml-20">문의내역</h4>
        <div class="col-11 pl-0 mb-30 mt-40">
          <el-input class="col-5" v-model="input">
            <template slot="prepend">제목</template>
          </el-input>
          <router-link to="/mypage/qst/list">
            <el-button class="fr" icon="el-icon-menu">목록보기</el-button>
          </router-link>
        </div>
        <ckeditor
          class="col-11 mb-30"
          v-model="editorDataInQ"
          :config="editorConfig"
        ></ckeditor>
        <h4 class="card-title pt-50 ml-20">답변내용</h4>
        <ckeditor
          class="col-11 mt-30 mb-30"
          v-model="editorDataRes"
          :config="editorConfig"
        ></ckeditor>
        <div class="col-11 mb-50">
          <el-button
            class="fr"
            icon="el-icon-circle-plus
"
            >답변등록</el-button
          >
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import card from "@/components/Cards/Card.vue";
import CKEditor from "ckeditor4-vue";
import { Input, Button } from "element-ui";

export default {
  components: {
    card,
    ckeditor: CKEditor.component,
    [Input.name]: Input,
    [Button.name]: Button,
  },
  created() {},
  computed: {},
  data() {
    return {
      input: "",
      editorDataInQ: "<p>문의하실 내용을 입력해주세요.</p>",
      editorDataRes: "<p>답변을 입력해주세요.</p>",
      editorConfig: {
        toolbar: [
          ["Styles", "Format", "Font", "FontSize"],
          ["Bold", "Italic"],
          ["TextColor", "BGColor"],
          [
            "NumberedList",
            "BulletedList",
            "-",
            "Outdent",
            "Indent",
            "-",
            "Blockquote",
            "CreateDiv",
            "-",
            "JustifyLeft",
            "JustifyCenter",
            "JustifyRight",
            "JustifyBlock",
            "-",
            "BidiLtr",
            "BidiRtl",
            "Language",
          ],
          ["Table"],
          ["Link"],
          ["Undo", "Redo"],
          ["About"],
        ],
        // The configuration of the editor.
      },
    };
  },
  methods: {
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
